if (typeof VideoBackgroundElement !== "function") {
  class VideoBackgroundElement extends HTMLElement {
    constructor() {
      super();

      this._eventSuccess = new Event("success");
      this._eventFail = new Event("fail");

      const video = this.querySelector("video");
      if (!video) return;

      // --- FORCE LOAD SOURCES (no lazy bugs) ---
      const sources = video.querySelectorAll("source");
      sources.forEach((source) => {
        if (source.dataset.src) {
          source.src = source.dataset.src;
        }
      });

      // Force reload
      video.load();

      // Try autoplay safely
      video.play().catch(() => {
        // Autoplay might be blocked, fallback to click
        document.addEventListener(
          "click",
          () => {
            video.play().catch(() => {});
          },
          { once: true },
        );
      });

      // --- EVENTS ---
      video.addEventListener("error", () => {
        this.switchFallback();
      });

      video.addEventListener("stalled", () => {
        if (!this.classList.contains("loaded")) {
          this.switchFallback();
        }
      });

      video.addEventListener("playing", () => {
        if (!this.classList.contains("loaded")) {
          this.classList.add("loaded");
          this.dispatchEvent(this._eventSuccess);
        }
      });
    }

    switchFallback() {
      const fallback = this.parentElement.querySelector(
        `[data-video-background-fallback][data-id="${this.dataset.id}"]`,
      );

      if (fallback) {
        fallback.append(
          fallback.querySelector("template").content.cloneNode(true),
        );

        const img = fallback.querySelector("img");
        if (img) {
          img.setAttribute("srcset", img.getAttribute("srcset"));
        }
      }

      this.dispatchEvent(this._eventFail);
    }
  }

  if (typeof customElements.get("video-background-element") === "undefined") {
    customElements.define("video-background-element", VideoBackgroundElement);
  }
}
